// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalBiAddress } from './medicalBiAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBiPractice {
    'additionalId'?: string;
    'address'?: MedicalBiAddress | null;
    'name'?: string;
    'npi'?: string;
    'phone'?: string;
    'taxId'?: string;
    'type'?: string;
    'networkStatus'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBiPractice>> = [
        {
            "name":     "additionalId",
            "baseName": "additionalId",
            "type":     "string"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "MedicalBiAddress"
        },
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "taxId",
            "baseName": "taxId",
            "type":     "string"
        },
        {
            "name":     "type",
            "baseName": "type",
            "type":     "string"
        },
        {
            "name":     "networkStatus",
            "baseName": "networkStatus",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBiPractice.attributeTypeMap;
    }
}
